export type { IconName, IconProps } from './Icon';
export { default as Icon, preloadIcon, preloadIcons } from './Icon';
